import { useState, useCallback } from 'react';
import { history } from 'umi';
import type { LoginInfo } from '@/services/authority/login';
import { login, logout } from '@/services/authority/login';
import { useModel } from '@@/plugin-model/useModel';

export default function useAuthModel () {
  const [user, setUser] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const { setInitialState } = useModel('@@initialState');

  const toLogin = useCallback(async (params: LoginInfo) => {
    setLoading(true);
    const [currentUser, e] = await login(params);
    setUser(currentUser);
    setError(e);
    await setInitialState((s) => ({ ...s, currentUser }));
    if (!e) {
      history.replace('/');
    }
    setLoading(false);
  }, []);

  const toLogout = useCallback(async () => {
    const [res] = await logout();
    if (res) {
      const { query = {} } = history.location;
      const { redirect } = query;
      if (window.location.pathname !== '/user/login' && !redirect) {
        history.replace({ pathname: '/user/login' });
      }
      setUser({ currentUser: null });
    }
  }, []);

  return {
    user,
    error,
    loading,
    toLogin,
    toLogout,
  };
}
